import React from 'react';

const styles = {
  footer: {
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '2rem 1.5rem',
    textAlign: 'center',
    color: '#555',
    fontSize: '0.8rem',
    background: '#0a0c14',
  },
  inner: {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  brand: {
    color: '#666',
    fontWeight: 600,
  },
  disclaimer: {
    color: '#444',
    fontSize: '0.72rem',
    maxWidth: 500,
    lineHeight: 1.5,
  },
};

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <div>
          <span style={styles.brand}>Miskulin Technologies</span>
          {' \u00A9 '}
          {new Date().getFullYear()}
        </div>
        <div style={styles.disclaimer}>
          RobloxForge is not affiliated with Roblox Corporation.
          Roblox is a trademark of Roblox Corporation.
        </div>
      </div>
    </footer>
  );
}
